module.exports = __webpack_public_path__ + "img/5.b3cd7824.jpg";